import axios from "axios";
import { msalInstance, getSilentRequest } from "@/msalConfig";

const api = axios.create({
	baseURL: process.env.VUE_APP_API_URL, // 例: "https://<your-api>/api"
	timeout: 30000,
});

// リクエスト直前：毎回 silent で最新トークン取得
api.interceptors.request.use(async (config) => {
	const req = getSilentRequest(); // { account, scopes }
	const res = await msalInstance.acquireTokenSilent(req);

	// 有効期限チェック
	const expiresOn = res.expiresOn; // Dateオブジェクト
	const now = new Date();
	const remainingMs = expiresOn.getTime() - now.getTime();
	const remainingMinutes = remainingMs / 1000 / 60;
	// console.log(remainingMinutes);

	// トークンの有効期限間近の場合トークンを更新（10分未満）
	if (remainingMinutes < 10) {
		const refreshed = await msalInstance.acquireTokenSilent({
			...req,
			forceRefresh: true,
		});
		config.headers.Authorization = `Bearer ${refreshed.accessToken}`;
	} else {
		config.headers.Authorization = `Bearer ${res.accessToken}`;
	}

	// config.headers["Content-Type"] = "application/json";

	// FormDataの場合はContent-Typeを設定しない
	if (!(config.data instanceof FormData)) {
		config.headers["Content-Type"] = "application/json";
	}

	return config;
});

// 401 は一度だけ強制更新してリトライ
api.interceptors.response.use(
	(r) => r,
	async (error) => {
		const { response, config } = error || {};
		if (response?.status === 401 && config && !config._retry) {
			config._retry = true;
			const req = getSilentRequest();
			const res = await msalInstance.acquireTokenSilent({ ...req, forceRefresh: true });
			config.headers.Authorization = `Bearer ${res.accessToken}`;
			return api.request(config);
		}
		return Promise.reject(error);
	}
);
export default api;
